module.exports = "https://static.cdns.space/qurangrowth-temp/img/m4.8d7cce29.webp";